//Digital Route

const Digital = () => import(/* webpackChunkName: "Digital" */ '../views/Digital')
// Digital Advertising
const DigitalAdvertising = () => import(/* webpackChunkName: "DigitalAdvertising" */ '../views/DigitalAdvertising')
const Adword = () => import(/* webpackChunkName: "Adword" */ '../views/DigitalAdvertising/Adword')
const SocialMedia = () => import(/* webpackChunkName: "DigitalAdvertising" */ '../views/DigitalAdvertising/SocialMedia')
const SMSBlast = () => import(/* webpackChunkName: "SMSBlast" */ '../views/DigitalAdvertising/SMSBlast')
const SmsTargeted = () => import(/* webpackChunkName: "SmsTargeted" */ '../views/DigitalAdvertising/SmsTargeted')


const digitalRoute = [
    {
      path: '/digital',
      name: 'digital',
      component: Digital
    },
    {
      path: '/digital-advertising',
      name: 'digitaladvertising',
      component: DigitalAdvertising,
      meta: { requiresAuth: true }
    },
    {
      path: '/digital-advertising/adword',
      name: 'adword',
      component: Adword,
      meta: { requiresAuth: true }
    },
    {
      path: '/digital-advertising/sms-blast',
      name: 'smsblast',
      component: SMSBlast,
      meta: { requiresAuth: true }
    },
    {
      path: '/digital-advertising/social-media',
      name: 'socmed',
      component: SocialMedia,
      meta: { requiresAuth: true },
    },
    {
      path: '/digital-advertising/sms-targeted',
      name: 'smstargeted',
      component: SmsTargeted,
      meta: { requiresAuth: true },
    },
]

export default digitalRoute;
